import { useSearchParams } from 'react-router';

import { URL_PARAMS } from '~/apps/product-plus/constants/url-params';

/**
 * Shared hook to determine if user should redirect to payment portal
 * Used across oddschecker-plus landing page templates
 */
export function useSubscriptionRedirect(isSubscribed: boolean, cancelPayment?: string | null) {
  const [searchParams] = useSearchParams();
  const isAttemptSubscribeOnPageLoad = searchParams.get(URL_PARAMS.IS_ATTEMPT_SUBSCRIBE);

  const shouldRedirectToPaymentPortal =
    isAttemptSubscribeOnPageLoad === 'true' && !isSubscribed && !(cancelPayment === 'true');

  return { searchParams, shouldRedirectToPaymentPortal };
}
